exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".newsletter{padding:80px 0}.newsletter .newsletter-error,.newsletter .newsletter-success,.newsletter h2{text-align:center}.newsletter h2{display:block;margin-bottom:40px}.theme-clean-dark .newsletter h2{color:#fff}.theme-clean-light .newsletter h2{color:#333}.theme-vantage-dark .newsletter h2{color:#fff}.theme-vantage-light .newsletter h2{color:#333}.theme-slanted-dark .newsletter h2{color:#fff}.theme-slanted-light .newsletter h2{color:#333}.newsletter .form{max-width:500px;margin:auto}", ""]);

// exports
